import { render, staticRenderFns } from "./TicketNoteContextMenuModal.vue?vue&type=template&id=89485f82&"
import script from "./TicketNoteContextMenuModal.vue?vue&type=script&lang=js&"
export * from "./TicketNoteContextMenuModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports